import { useRouter } from "next/router"

export const useNavigateTo = () => {
  const router = useRouter()

  return (to) => {
    router.push(to).then(() => window.scrollTo(0, 0))
  }
}
